var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component"},'component',{ ..._vm.content, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }